import { render } from "./SelectType.vue?vue&type=template&id=fb8c81a4&scoped=true&ts=true"
import script from "./SelectType.vue?vue&type=script&lang=ts"
export * from "./SelectType.vue?vue&type=script&lang=ts"

import "./SelectType.vue?vue&type=style&index=0&id=fb8c81a4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8c81a4"]])

export default __exports__